module.exports = __webpack_public_path__ + "img/oufu_100x125x11_5b.prt.1bbb1005.jpg";